import { render, staticRenderFns } from "./uiTag.vue?vue&type=template&id=3e198220&scoped=true"
import script from "./uiTag.vue?vue&type=script&lang=js"
export * from "./uiTag.vue?vue&type=script&lang=js"
import style0 from "./uiTag.vue?vue&type=style&index=0&id=3e198220&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e198220",
  null
  
)

export default component.exports